<template>
  <div class="alerts">
    <v-fade-transition v-for="alert in alerts" :key="alert.id">
      <div
        :class="[
          'alert-item rounded-10 border-default d-flex align-center p-relative pa-1 mt-2 shadow-base',
          `alert-${alert.type}`,
        ]"
      >
        <div :class="['indicator', alert.type]"></div>
        <img
          :src="alertIcons[alert.type]"
          alt=""
          width="48px"
          height="48px"
          class="ml-4"
        />
        <div class="ml-5 flex-1 py-3" style="word-break: break-word">
          <div class="heading-5 font-weight-medium">{{ $t(alert.title) }}</div>
          <div class="mt-2 pr-5">
            <div
              class="text-4 gray--text white-space-pre-line"
              v-if="!alert.html"
              style="line-height: 18px"
            >
              {{ $t(alert.message) }}
            </div>
            <div v-html="alert.html" v-else></div>
          </div>
        </div>
        <v-icon
          x-small
          aria-label="close"
          @click="removeAlert(alert.id)"
          class="close-alert-btn"
          >mdi-close</v-icon
        >
      </div>
    </v-fade-transition>
    <notifications />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Notifications from "./Notifications";

export default {
  components: {
    Notifications,
  },
  computed: mapGetters({
    alerts: "alerts",
  }),
  data: () => ({
    alertIcons: {
      success: require("@/assets/icons/alert-success.svg"),
      error: require("@/assets/icons/alert-error.svg"),
      warning: require("@/assets/icons/alert-warning.svg"),
    },
  }),
  methods: {
    removeAlert(id) {
      this.$store.dispatch("removeAlert", id);
    },
  },
  mounted() {
    setInterval(() => {
      this.alerts
        .filter((al) => al.expiry - new Date().valueOf() < 0)
        .map((al) => al.id)
        .forEach(this.removeAlert);
    }, 100);
  },
};
</script>
<style lang="scss" >
.alerts {
  position: fixed;
  right: 20px;
  bottom: 64px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .alert-item {
    background-color: white;
    width: 504px;
    max-width: calc(100vw - 40px);
    .indicator {
      position: absolute;
      width: 6px;
      height: calc(100% - 10px);
      border-radius: 50px;
    }
    .close-alert-btn {
      position: absolute;
      right: 10px;
      top: 10px;
    }
  }
}
.theme--dark {
  .alert-item {
    background-color: #222e3b !important;
  }
}
</style>